"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOauth2Client = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const actionTypes = require("../../actionTypes/auth/oauth2");
const actions = require("../../actions/auth/oauth2");
function getOauth2Client(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.GET_OAUTH2_CLIENT_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/oauth2/scope?client_id=${action.payload.client_id}&scope=${action.payload.scope}&redirect_uri=${action.payload.redirect_uri}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        return (0, rxjs_1.of)(actions.getOauth2ClientSuccess(response));
    }), (0, operators_1.catchError)((x) => (0, rxjs_1.of)(actions.getOauth2ClientFailure((0, errorHandling_1.parseAjaxErrorResponse)(x)))))));
}
exports.getOauth2Client = getOauth2Client;
//# sourceMappingURL=oauth2.js.map